module.exports = __webpack_public_path__ + "static/media/qrcode-pvh.3f22e97a.png";